import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { convertUrlsToLinks } from '@/functions/convertUrlsToLinks';
import { RESPONSIVE_MARGIN } from '@/functions/createTheme';

type Props = {
  htmlText: string;
};

export const Description: React.FC<Props> = ({ htmlText }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        px: 2,
        py: RESPONSIVE_MARGIN,
        backgroundColor: '#f5f5f5'
      }}
    >
      <Typography
        sx={{
          fontSize: theme.typography.body2.fontSize,
          wordWrap: 'break-word'
        }}
        dangerouslySetInnerHTML={{
          __html: `"${convertUrlsToLinks(htmlText)}"`
        }}
      />
    </Paper>
  );
};
